import { useState, useEffect } from 'react';

const INTERVAL = 500;
const RETRY = 5;

export function useGetDomNodeWithInterval({
	selector = '', // string for ID (target-id) not with hash (#target-id)
	myDocument = undefined,
}: {
	selector: string;
	myDocument?: Document;
}) {
	const [seconds, setSeconds] = useState<number>(0);

	const domNode =
		myDocument !== undefined
			? (myDocument.getElementById(selector) as HTMLElement)
			: (document.getElementById(selector) as HTMLElement);

	useEffect(() => {
		const interval = setInterval(() => {
			setSeconds((prevSeconds) => prevSeconds + 1);
		}, INTERVAL);

		// Emergency exit, do not wait more than this value
		if (seconds >= RETRY) {
			clearInterval(interval);
		}

		if (domNode) {
			clearInterval(interval);
		}

		return () => clearInterval(interval);
	}, [seconds]);

	return domNode;
}
